import keyMirror from "keymirror";

export default keyMirror({
  ADDRESS: null,
  MLS: null,
  INFO: null,
  MEDIA_EDIT: null,
  MEDIA_SETTINGS: null,
  SETTINGS: null,
  STATS: null,
  LINKS: null,
  FLYER: null,
  DOWNLOAD: null,
  VIDEO: null,
  IMMERSIVE_3D_TOUR: null,
  UI_MEET_3D: null,
  RANSOM_REVIEW: null,
});
